var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.2,2.1C34.7,2.1,1.9,34.9,1.9,75.3s32.8,73.2,73.2,73.2,73.2-32.8,73.2-73.2S115.6,2.1,75.2,2.1ZM76,135.5c-33.2,0-60.2-26.9-60.2-60.2S42.8,15.1,76,15.1s60.2,26.9,60.2,60.2-26.9,60.2-60.2,60.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.3,42.4l-19.2.9v-6.2c0-2.4-2.3-4.1-4.5-3.4l-31.3,10.1v64.7l29.6,10.7c3,1.1,6.2-1.2,6.2-4.5v-5.9l19.5.6c2,0,3.6-1.5,3.6-3.5v-59.8c0-2.1-1.8-3.9-3.9-3.8ZM75.8,78v1.2h-2.1v-1.2c-.8-.4-1.3-1.2-1.3-2.1s.5-1.7,1.3-2.1v-1.5h2.1v1.5c.8.4,1.3,1.2,1.3,2.1s-.5,1.7-1.3,2.1ZM97.1,102.3h-16v-52.7h16v52.7Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitIcon);
export default __webpack_public_path__ + "static/media/exit_icon.cc2a2f971dcb6b5d97c575e6de00d35c.svg";
export { ForwardRef as ReactComponent };